import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import GalleryInner from '../Components/Gallery/GalleryInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Gallery() {
    return (
        <>
            <SEO 
                title="Photo Gallery - Tourm Travel Agency"
                description="Browse our photo gallery showcasing beautiful destinations and memorable travel experiences from around the world."
                url="/gallery"
            />
            <HeaderOne />
            <Breadcrumb
                title="Gallery"
            />
            <GalleryInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Gallery
